// @ts-nocheck
import React, { useRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';
import styles from '../styles/DCBUserDetails.module.css';

import { HeaderS } from '@shared/ui/header';
import { Footer } from '@shared/ui/footer';
import { changeLanguage } from '@entities/language/store';
import { setHtmlDirection } from '@shared/utils';
import { Banner } from '@features/phone-subscription';
import { AR_lang, EN_lang } from '@entities/language';
import { useQuery } from '@shared/hooks';
import axios from 'axios';
import Config from '@shared/config/constants/config-main';
import { v4 } from 'uuid';
import { unsubBannerConfig } from '@shared/config/constants/Banners';

const DCBUserDetails = ({
  isArabic = false,
  languageConfig = { availableLanguages: [EN_lang, AR_lang] },
}) => {
  const { i18n } = useTranslation();
  const formStartRef = useRef(null);
  const howItWorksRef = useRef(null);

  const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);

  const [isUserRequestsShown, setIsUserRequestsShown] = useState(false);

  const { query } = useQuery();

  useEffect(() => {
    if (isArabic) {
      let lang = { locale: 'ar', displayName: 'العربية', direction: 'rtl' };
      i18n.changeLanguage(lang.locale);
      changeLanguage(lang);
      setHtmlDirection('rtl');
    }
  }, []);

  useEffect(() => {
    const msisdn = query.get('msisdn') || '';
    const subscriberId = query.get('subscriberId') || '';

    if (!msisdn && !subscriberId) return;

    const getSubsciptionDetails = async () => {
      const res = await axios.post(`${Config.API_URL}/v2/subscription/details`, {
        msisdn,
        subscriberId,
      });

      const userData = res.data?.data || null;

      if (!userData) {
        setError(res.data?.message);
        return;
      }

      setUserData(userData);
    };

    getSubsciptionDetails();
  }, [query]);

  const subscriptionDateTime = userData?.subscriptionDateTime || '';
  const unsubscriptionDateTime = userData?.unsubscriptionDateTime || '';
  const subscriptionLP = userData?.subscriptionLP || '';
  const subscriptionIPAddress = userData?.subscriptionIPAddress || '';
  const country = userData?.country || '';
  const operator = userData?.operator || '';
  const device = userData?.device || '';
  const apiSource = userData?.source || '';
  const currentBillingStatus = userData?.currentBillingStatus || '';
  const billingPlan = userData?.billingPlan || '';
  const userAgent = userData?.userAgent || '';

  const userRequestsJSON = userData?.requests || '{}';
  const userRequestsParsed = JSON.parse(userRequestsJSON) || {};

  const handleCopyLPLink = async () => {
    try {
      await navigator.clipboard.writeText(subscriptionLP);

      alert('Link was copied to your clipboard');
    } catch {
      alert('Link was not copied');
    }
  };

  const handleOpenUserRequests = () => {
    setIsUserRequestsShown(true);
  };

  return (
    <article className="landing-article">
      <HeaderS
        formStartRef={formStartRef}
        howItWorksRef={howItWorksRef}
        languageConfig={{ ...languageConfig, showLanguageSelector: false }}
        isCC
        isUnsubPage
      />
      <Banner bannerConfig={unsubBannerConfig} />
      <Container className="container-sm">
        <section className="landing-section-4" style={{ paddingBottom: '200px' }}>
          <div
            style={{
              backgroundColor: 'grey',
              borderRadius: '16px',
              padding: '16px',
            }}
          >
            <ul
              style={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                gap: '12px',
              }}
            >
              {!!subscriptionDateTime && (
                <>
                  <li className="userDetailsLi">
                    <div className={styles.userDetailsLiItem}>
                      <p>Subscription date time:</p>

                      <b>{subscriptionDateTime}</b>
                    </div>
                  </li>
                  <div className={styles.separatorLiDetails} />
                </>
              )}

              {!!unsubscriptionDateTime && (
                <>
                  <li className="userDetailsLi">
                    <div className={styles.userDetailsLiItem}>
                      <p>Unsubscription date time:</p>

                      <b>{unsubscriptionDateTime}</b>
                    </div>
                  </li>
                  <div className={styles.separatorLiDetails} />
                </>
              )}

              {!!subscriptionLP && (
                <>
                  <li className="userDetailsLi">
                    <div className={styles.userDetailsLiItem}>
                      <p>Subscription LP:</p>

                      <a href={subscriptionLP} target="_blank" rel="noopener noreferrer">
                        LINK
                      </a>

                      <div onClick={handleCopyLPLink} style={{ cursor: 'pointer' }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          fill="#000000"
                          viewBox="0 0 256 256"
                        >
                          <path d="M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z"></path>
                        </svg>
                      </div>
                    </div>
                  </li>
                  <div className={styles.separatorLiDetails} />
                </>
              )}

              {!!subscriptionIPAddress && (
                <>
                  <li className="userDetailsLi">
                    <div className={styles.userDetailsLiItem}>
                      <p>Subscription IP:</p>

                      <b>{subscriptionIPAddress}</b>
                    </div>
                  </li>
                  <div className={styles.separatorLiDetails} />
                </>
              )}

              {!!country && (
                <>
                  <li className="userDetailsLi">
                    <div className={styles.userDetailsLiItem}>
                      <p>Country:</p>

                      <b>{country}</b>
                    </div>
                  </li>
                  <div className={styles.separatorLiDetails} />
                </>
              )}

              {!!operator && (
                <>
                  <li className="userDetailsLi">
                    <div className={styles.userDetailsLiItem}>
                      <p>Operator:</p>

                      <b>{operator}</b>
                    </div>
                  </li>
                  <div className={styles.separatorLiDetails} />
                </>
              )}

              {!!device && (
                <>
                  <li className="userDetailsLi">
                    <div className={styles.userDetailsLiItem}>
                      <p>Device:</p>

                      <b>{device}</b>
                    </div>
                  </li>
                  <div className={styles.separatorLiDetails} />
                </>
              )}

              {!!apiSource && (
                <>
                  <li className="userDetailsLi">
                    <div className={styles.userDetailsLiItem}>
                      <p>API source:</p>

                      <b>{apiSource}</b>
                    </div>
                  </li>
                  <div className={styles.separatorLiDetails} />
                </>
              )}

              {!!currentBillingStatus && (
                <>
                  <li className="userDetailsLi">
                    <div className={styles.userDetailsLiItem}>
                      <p>Current billing status:</p>

                      <b>{currentBillingStatus}</b>
                    </div>
                  </li>
                  <div className={styles.separatorLiDetails} />
                </>
              )}

              {!!billingPlan && (
                <>
                  <li className="userDetailsLi">
                    <div className={styles.userDetailsLiItem}>
                      <p>Billing plan:</p>

                      <b>{billingPlan}</b>
                    </div>
                  </li>
                  <div className={styles.separatorLiDetails} />
                </>
              )}

              {!!userAgent && (
                <>
                  <li className="userDetailsLi">
                    <div className={styles.userDetailsLiItem}>
                      <p>User agent:</p>

                      <b>{userAgent}</b>
                    </div>
                  </li>
                  <div className={styles.separatorLiDetails} />
                </>
              )}

              {!!userData?.requests && (
                <li className="userDetailsLi">
                  <div className="userDetailsLiItem">
                    <p>User requests:</p>

                    {!isUserRequestsShown ? (
                      <button onClick={handleOpenUserRequests}>Open requests</button>
                    ) : null}
                  </div>
                </li>
              )}
            </ul>

            {!!userData?.requests && isUserRequestsShown && (
              <>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    wordBreak: 'break-all',
                  }}
                >
                  {userRequestsParsed.map((obj) => {
                    return (
                      <div key={v4()}>
                        {Object.keys(obj).map((name) => {
                          if (obj?.[name] && obj?.[name]?.length > 50) {
                            return (
                              <div key={v4()}>
                                {name}:
                                <p
                                  style={{
                                    maxWidth: '450px',
                                    wordWrap: 'break-word',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  {obj?.[name] || ''}
                                </p>
                              </div>
                            );
                          }

                          return (
                            <div key={v4()} style={{ display: 'flex' }}>
                              {name}:
                              <p
                                style={{
                                  fontWeight: 'bold',
                                  maxWidth: '450px',
                                  wordWrap: 'break-word',
                                }}
                              >
                                {obj?.[name] || ''}
                              </p>
                            </div>
                          );
                        })}

                        <div
                          className={styles.separatorLiDetails}
                          style={{ marginTop: '32px', marginBottom: '32px', height: '3px' }}
                        />
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>

          <Footer
            isWhite
            hideFeatures
            isOTP
            vipFeaturesConfig={{ hide: true }}
            followUsConfig={{ hide: true }}
            moreAboutUsConfig={{ hide: true }}
            aboutUsConfig={{ hide: true }}
          />
        </section>
      </Container>
    </article>
  );
};

export { DCBUserDetails };
